import { useState } from 'react';

export function useProfile(defaultChoice) {
    const [value, setValue] = useState({});

    return {
        value,
        setValue,
    };
}
